import type { GridApi, IClientSideRowModel, IRowNode } from "ag-grid-community";

import type { ColumnRow } from "../ColumnSelectionGrid.tsx";

type GridApiWithModel = GridApi<ColumnRow> & {
  getModel?: () => IClientSideRowModel<ColumnRow> | null;
};

const getClientSideRowModel = (api: GridApi<ColumnRow> | null | undefined): IClientSideRowModel<ColumnRow> | null => {
  return (api as GridApiWithModel | null | undefined)?.getModel?.() ?? null;
};

const visitNodes = (nodes: IRowNode<ColumnRow>[] | null | undefined, visitor: (node: IRowNode<ColumnRow>) => void) => {
  if (!nodes) {
    return;
  }

  nodes.forEach((node) => {
    visitor(node);

    const childNodes = node.childrenAfterSort ?? node.childrenAfterGroup;
    if (childNodes?.length) {
      visitNodes(childNodes, visitor);
    }
  });
};

// Iterates every row node in the underlying Client-Side Row Model order, ignoring filters.
export const forEachRowNodeInStableOrder = (
  api: GridApi<ColumnRow> | null | undefined,
  iterator: (node: IRowNode<ColumnRow>) => void,
): boolean => {
  const rowModel = getClientSideRowModel(api);
  const rootNode = rowModel?.rootNode;

  if (!rootNode) {
    return false;
  }

  const topLevelNodes = rootNode.childrenAfterSort ?? rootNode.childrenAfterGroup;

  if (!topLevelNodes?.length) {
    return false;
  }

  visitNodes(topLevelNodes, iterator);
  return true;
};
